// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"239":"1e24daa8","732":"6070fe24","977":"1ef6d857"}[chunkId] + ".chunk.js");